export default __webpack_public_path__ + "static/media/settings.a1356a1b.gif";